module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/131987db946b072a0c426a4582b153b4.png";